import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import NewBrandLogoIcon from 'components/Images/NewBrandLogoIcon';
import Loader from 'components/Loader';
import WbpForm from 'pages/FlutterWbpForm/WbpForm';
import { get } from 'lib/api';
import { handleFlutterCallbacks } from 'lib/utils';

import BackIcon from '../../components/Images/BackButton';
import * as Styles from './styles';

const FlutterWbpForm = () => {
  const location = useLocation();
  const bookId = location.pathname.split('/')[2];

  const [loading, setLoading] = useState(false);
  const [bookData, setBookData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await get('/content_api/book.creator_ben_prog', {
          params: {
            book_id: bookId,
            is_novel: 1,
          },
        });
        setBookData(response.books[0]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    if (bookId) {
      fetchData();
    }
  }, [bookId]);

  function handleBackClick() {
    handleFlutterCallbacks({
      method: 'onBackPressed',
      data: {},
      elseDoThis: () => {},
    });
    console.log('----onBackPressed----');
  }

  return (
    <Styles.Wrapper>
      <Styles.BackIconWrapper>
        <BackIcon onClick={handleBackClick} />
        <NewBrandLogoIcon title="Pocket Writer" />
      </Styles.BackIconWrapper>
      {loading ? (
        <Loader />
      ) : (
        <>
          {bookData && (
            <Styles.FormWrapper>
              <WbpForm
                setCurrentStep={() => {}}
                book_name={bookData?.book_title}
                book_language={bookData?.language}
                resetSteps={() => {}}
                id={bookId}
                showTerms={() => {}}
                reappliedProgramId={1}
                book={bookData}
              />
            </Styles.FormWrapper>
          )}
        </>
      )}
    </Styles.Wrapper>
  );
};

export default FlutterWbpForm;
